import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseLockComponent } from './lock.component';

const routes = [
    {
        path     : 'pages/auth/lock',
        component: FuseLockComponent
    }
];

@NgModule({
    declarations: [
        FuseLockComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ]
})

export class LockModule
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/authentication/lock/lock.module.ts